import {Adres, AdresDto} from './adres';
import {ClientDienst, ClientDienstDto} from './client-dienst';
import {ClientFiche, ClientFicheDto} from './client-fiche';

export class Client {

  static deserialize(dto: ClientDto): Client {
    return new Client(
      dto.id,
      dto.voornaam,
      dto.achternaam,
      dto.nummer,
      Adres.deserialize(dto.adres),
      (dto.diensten || []).map(dienstDto => ClientDienst.deserialize(dienstDto)),
      dto.archiveringsTijdstip ? new Date(dto.archiveringsTijdstip) : undefined,
      dto.fiche ? ClientFiche.deserialize(dto.fiche) : undefined,
    );
  }

  constructor(
    private id: string,
    private voornaam: string,
    private achternaam: string,
    private nummer: string,
    private adres: Adres,
    public diensten: Array<ClientDienst>,
    private archiveringsTijdstip?: Date,
    private fiche?: ClientFiche,
  ) {
  }

  getId(): string {
    return this.id;
  }

  hasId(id: string): boolean {
    return this.getId() === id;
  }

  getVoornaam(): string {
    return this.voornaam;
  }

  getAchternaam(): string {
    return this.achternaam;
  }

  getNaam(): string {
    return `${this.getAchternaam()} ${this.getVoornaam()}`;
  }

  getNummer(): string {
    return this.nummer;
  }

  hasNummer(nummer: string): boolean {
    return this.nummer === nummer;
  }

  getZoneIds(): Array<string> {
    return this.diensten.map(dienst => dienst.getZoneId());
  }

  getUniqueZoneIds(): Array<string> {
    return [...new Set(this.getZoneIds())];
  }

  getAdres(): Adres {
    return this.adres;
  }

  getDiensten(): Array<ClientDienst> {
    return this.diensten;
  }

  getDienst(id: string): ClientDienst {
    return this.diensten.find(dienst => dienst.hasId(id));
  }

  getDienstIds(): Array<string> {
    return this.diensten.map(dienst => dienst.getId());
  }

  hasDienst(id: string): boolean {
    return !!this.getDienst(id);
  }

  getArchiveringsTijdstip(): Date {
    return this.archiveringsTijdstip;
  }

  isGearchiveerd(): boolean {
    return !!this.archiveringsTijdstip;
  }

  getFiche(): ClientFiche | undefined {
    return this.fiche;
  }

  hasFiche(): boolean {
    return !!this.fiche;
  }
}

export interface ClientDto {
  id: string;
  voornaam: string;
  achternaam: string;
  nummer: string;
  adres: AdresDto;
  archiveringsTijdstip: string;
  diensten: Array<ClientDienstDto>;
  fiche?: ClientFicheDto;
}
